module.exports = __webpack_public_path__ + "static/media/rubio.d7e93160.png";